import { BsGithub } from "react-icons/bs";
import { HiOutlineMail } from "react-icons/hi";

const SocialIcons = () => {
  return (
    <div className="flex-col justify-center items-center gap-1 fixed bottom-0 md:right-[5%] xl:right-[5vw] dark:text-highlight hidden md:flex z-20">
      <a
        className="relative flex items-center cursor-pointer group"
        href="https://github.com/wBlanck"
        target="_blank"
        rel="noreferrer">
        <BsGithub size={30} />
        <span className="w-0 absolute overflow-hidden ease-linear duration-300 right-8 tracking-wider font-normal font-secondary dark:text-textHeading group-hover:w-[70px] text-gray-900">
          wBlanck
        </span>
      </a>
      <a
        className="relative flex items-center cursor-pointer group"
        href="mailto:blanck.william@gmail.com"
        target="_blank"
        rel="noreferrer">
        <HiOutlineMail size={30} />
        <span className="w-0 absolute overflow-hidden ease-linear duration-300 right-8 tracking-wider font-normal font-secondary dark:text-textHeading group-hover:w-[220px] text-gray-900">
          blanck.william@gmail.com
        </span>
      </a>
      <div className="h-24 w-[1px] dark:bg-textHeading bg-gray-900" />
    </div>
  );
};

export default SocialIcons;
